import styled from 'styled-components';

export const StyledError = styled.b`
    color: #ff0000;
    font-size: 1em;
    font-weight: 500;
    display: block;
`;

export const StyledLabel = styled.label`
    display: inline-block;
    margin: 0 1em .5rem 0;
`;

export default StyledError;
